/**
 * Aura cursor — a soft disc that trails the pointer.
 * Immersive + fine pointer only. Never replaces the native cursor elsewhere.
 */

/* Inlined rather than imported — see the note at the top of mode.js. */
const getMode = () =>
  document.documentElement.classList.contains('mode-immersive') ? 'immersive' : 'standard';
const canBeImmersive = () =>
  window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
  !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const aura = document.querySelector('.aura');
if (aura) {
  const INTERACTIVE = 'a, button, input, textarea, select, summary, [role="button"], [draggable="true"]';
  const LERP = 0.15;

  let pointerX = window.innerWidth / 2;
  let pointerY = window.innerHeight / 2;
  let x = pointerX;
  let y = pointerY;
  let scale = 1;
  let targetScale = 1;
  let frame = null;
  let running = false;

  const render = () => {
    x += (pointerX - x) * LERP;
    y += (pointerY - y) * LERP;
    scale += (targetScale - scale) * 0.2;
    aura.style.transform = `translate3d(${x.toFixed(2)}px, ${y.toFixed(2)}px, 0) scale(${scale.toFixed(3)})`;
    frame = requestAnimationFrame(render);
  };

  const onMove = (event) => {
    pointerX = event.clientX;
    pointerY = event.clientY;
    aura.classList.add('is-visible');
    targetScale = event.target.closest(INTERACTIVE) ? 1.4 : 1;
  };

  const onDown = () => { targetScale *= 0.82; };
  const onUp = (event) => {
    targetScale = event.target.closest(INTERACTIVE) ? 1.4 : 1;
  };
  const onLeave = () => aura.classList.remove('is-visible');

  function start() {
    if (running) return;
    running = true;
    window.addEventListener('pointermove', onMove, { passive: true });
    window.addEventListener('pointerdown', onDown, { passive: true });
    window.addEventListener('pointerup', onUp, { passive: true });
    document.addEventListener('pointerleave', onLeave);
    frame = requestAnimationFrame(render);
  }

  function stop() {
    if (!running) return;
    running = false;
    window.removeEventListener('pointermove', onMove);
    window.removeEventListener('pointerdown', onDown);
    window.removeEventListener('pointerup', onUp);
    document.removeEventListener('pointerleave', onLeave);
    if (frame) cancelAnimationFrame(frame);
    aura.classList.remove('is-visible');
    aura.style.transform = '';
  }

  const sync = () => {
    if (getMode() === 'immersive' && canBeImmersive()) start();
    else stop();
  };

  sync();
  document.addEventListener('ss:modechange', sync);
}
